import React, { useState, useEffect } from "react";
import "./DonationForm.css";
import axios from "axios";

// Import diya image
import diyaImage from "./assets/DiwaliCandle.png"; // Add your diya image
// Import marigold garland images
// import marigoldLeft from "./assets/marigold-garland-left.png";
// import marigoldRight from "./assets/marigold-garland-right.png";

const DonationForm = () => {
  const [selectedMainOption, setSelectedMainOption] = useState(null);
  const [formData, setFormData] = useState({
    amount: "",
    name: "",
    email: "",
    mobile: "",
    dob: "",
    want80G: false,
    receivePrasad: false,
    panNumber: "",
    prasadAddress: {
      doorNumber: "",
      houseName: "",
      streetName: "",
      area: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
  });

  // Donation options for the main purple section (top 4 boxes)
  const mainDonationOptions = [
    { meals: 50, amount: 1000 },
    { meals: 100, amount: 2000 },
    { meals: 250, amount: 5000 },
    { meals: 500, amount: 10000 },
  ];

  // Donation options for the larger white section
  const largerDonationOptions = [
    { meals: 1000, amount: 20000 },
    { meals: 2500, amount: 50000 },
    { meals: 5000, amount: 100000 },
    { meals: 10000, amount: 200000 },
  ];

  const handleMainOptionClick = (amount) => {
    setSelectedMainOption(amount);
    setFormData((prev) => ({
      ...prev,
      amount: amount.toString(),
    }));
  };

  // const handleChange = (e) => {
  //   if (e.target.name === "amount") {
  //     setSelectedMainOption(null);
  //   }
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  // const handleCheckboxChange = (e) => {
  //   const { name, type, checked, value } = e.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  // const handlePrasadAddressChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     prasadAddress: {
  //       ...prev.prasadAddress,
  //       [name]: value,
  //     },
  //   }));
  // };

  // New function to handle donation button clicks
  const handleDonateNowClick = async (amount, meals) => {
    // Set the selected amount in form data
    setFormData((prev) => ({
      ...prev,
      amount: amount.toString(),
    }));

    // Open payment gateway directly
    await initiatePayment(amount, meals);
  };

  // Function to initiate payment
  const initiatePayment = async (amount, meals = null) => {
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: amount,
          currency: "INR",
        }
      );

      const order = response.data;
      let sevaDescription = meals ? `Diwali Food Donation - ${meals} Meals` : "Diwali Food Donation";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: amount * 100,
        currency: "INR",
        name: "ISKCON Donation",
        description: sevaDescription,
        order_id: order.id,
        notes: {
          donationType: "Diwali Food Donation",
          meals: meals || "Custom Amount",
          amount: amount,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: {
                  amount: amount,
                  meals: meals,
                  paymentStatus: "Successful",
                  submissionDate: new Date().toISOString(),
                },
              }
            );

            if (verificationResponse.data.success) {
              await storePaymentData("Payment Successful", amount, meals);
              isFormDataStored = true;
              alert("Payment Successful! Thank you for your donation.");
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storePaymentData("Payment Failed", amount, meals);
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.name || "",
          email: formData.email || "",
          contact: formData.mobile || "",
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storePaymentData("Payment Failed", amount, meals);
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storePaymentData("Payment Failed", amount, meals);
        isFormDataStored = true;
      }
    }
  };

  // Function to store payment data
  const storePaymentData = async (paymentStatus, amount, meals) => {
    const paymentData = {
      amount: amount,
      meals: meals || "Custom",
      paymentStatus: paymentStatus,
      submissionDate: new Date().toISOString(),
      name: formData.name || "Not Provided",
      email: formData.email || "Not Provided",
      mobile: formData.mobile || "Not Provided",
    };

    const formBody = new URLSearchParams(paymentData).toString();

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbzxYif8qOVlVduU4e4dPx18NaFI7SxLzOyIHpd1btJERywNXgC3dS2e19pLOmIQC-yvZQ/exec",
        {
          method: "POST",
          body: formBody,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      
      // Reset form data after successful payment
      if (paymentStatus === "Payment Successful") {
        setFormData({
          amount: "",
          name: "",
          email: "",
          mobile: "",
          dob: "",
          want80G: false,
          receivePrasad: false,
          panNumber: "",
          prasadAddress: {
            doorNumber: "",
            houseName: "",
            streetName: "",
            area: "",
            country: "",
            state: "",
            city: "",
            pincode: "",
          },
        });
        setSelectedMainOption(null);
      }
    } catch (error) {
      console.error("Payment data storage error:", error);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (
  //     formData.amount === "" ||
  //     formData.name === "" ||
  //     formData.email === "" ||
  //     formData.mobile === "" ||
  //     formData.dob === "" ||
  //     (formData.want80G && formData.panNumber === "")
  //   ) {
  //     alert("Please enter all required fields");
  //     return;
  //   }

  //   if (formData.receivePrasad) {
  //     const addressFields = formData.prasadAddress;
  //     const areFieldsEmpty = Object.values(addressFields).some(
  //       (value) => value.trim() === ""
  //     );
  //     if (areFieldsEmpty) {
  //       alert("Please fill in all address fields to receive Prasadam.");
  //       return;
  //     }
  //   }

  //   const totalAmount = getTotalAmount();
  //   await initiatePayment(totalAmount);
  // };

  const getTotalAmount = () => {
    return parseFloat(formData.amount || 0);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="donation-page-container">
      
      {/* Header Content with Diya Images */}
      <div className="header-content">
       <div className="diwali-support">
  <img src={diyaImage} alt="Diya" className="diya-icon" />
  <span className="diwali-message">
    THIS DIWALI <span className="support-text">SUPPORT ISKCON TO FEED</span> HUNGRY PEOPLE
  </span>
  <img src={diyaImage} alt="Diya" className="diya-icon" />
</div>
        <div className="highlight-box">Donate Food This Diwali</div>
      </div>

      {/* Main Donation Options */}
      <div className="main-options-section">
        <div className="main-options-grid">
          {mainDonationOptions.map((option, index) => (
            <div
              key={index}
              className={`donation-option-box ${
                selectedMainOption === option.amount ? "selected" : ""
              }`}
              onClick={() => handleMainOptionClick(option.amount)}
            >
              <p className="meals-text">Donate {option.meals} Meals</p>
              <p className="price-display">₹ {option.amount.toLocaleString()}</p>
              <button 
                className="donate-btn-yellow"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the parent div click
                  handleDonateNowClick(option.amount, option.meals);
                }}
              >
                Donate Now
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Larger Donation Options */}
      <div className="larger-options-box">
        {largerDonationOptions.map((option, index) => (
          <div key={index} className="larger-option-row">
            <button className="meals-btn-purple">
              Donate {option.meals.toLocaleString()} Meals
            </button>
            <p className="price-in-white-box">₹ {option.amount.toLocaleString()}</p>
            <button 
              className="donate-btn-yellow small-yellow-btn"
              onClick={() => handleDonateNowClick(option.amount, option.meals)}
            >
              Donate Now
            </button>
          </div>
        ))}
        <p className="international-text">For international transactions</p>
        <button 
          className="contribute-btn-main"
          onClick={() => {
            // For contribute now, you might want to open a form or custom amount
            const customAmount = prompt("Enter donation amount:");
            if (customAmount && !isNaN(customAmount) && customAmount > 0) {
              handleDonateNowClick(parseFloat(customAmount), "Custom");
            }
          }}
        >
          CONTRIBUTE NOW
        </button>
      </div>

    
    </div>
  );
};

export default DonationForm;